import { Fragment, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Row, Col, Image, Button, Form } from "react-bootstrap";
import useAxios from "axios-hooks";
import BrandContext from "./BrandContext";

export default function Email(props) {
    const params = useParams();
    const nav = useNavigate();
    const [email, setEmail] = useState('')

    const [
        { loading: working },
        executePut
    ] = useAxios(
        {
            url: '/pr/create',
            method: 'POST'
        },
        { manual: true }
    )

    function createDraft() {
        executePut({
            data: {
                customer: { email },
                accountId: params.accountId,
                brandId: params.brandId
            }
        })
            .then((r) => {
                nav(`../${r.data.id}/details`)
            })
            .catch((e) => {
                console.error(e)
            })
            .finally(() => {

            })
    }

    const handleKeypress = e => {
        if (e.keyCode === 13) { createDraft(); }
    };

    return (
        <BrandContext.Consumer>
            {theme =>
                <Fragment>
                    <Container fluid="md" style={{ paddingTop: "50px", paddingBottom: "50px" }}>
                        <Row>
                            <Col sm={{ span: true, order: 'first' }} xs={{ span: 12, order: 'last' }} style={{ padding: "15px" }}>
                                <p style={{ fontSize: "14px" }}><span className="fw-bold">Create</span> <span className="fw-bold text-swiftrev">&gt;</span> <span className="sr-light">Promote</span> <span className="fw-bold text-swiftrev">&gt;</span> <span className="sr-light">Submit</span></p>
                                <p className="fw-bold" style={{ fontSize: "24px", lineHeight: "26px" }}>Let's get started</p>
                            </Col>
                            <Col sm={{ span: 'auto', order: 'last' }} xs={{ span: 12, order: 'first' }} style={{ padding: "15px", display: "grid", alignContent: "start", justifyContent: "start" }}>
                                <Image style={{ height: "50px" }} fluid src={theme?.marketing?.logo}></Image>
                            </Col>
                        </Row>
                        <Row className="swiftrev-alert" style={{ margin: "12px 0 0 0" }}>
                            <Col md="12" style={{ padding: "35px" }}>
                                <Form.Control autoFocus required type="email" placeholder="Enter your email"
                                    onChange={(e) => setEmail(e.target.value)}
                                    onKeyUp={handleKeypress} />
                            </Col>
                        </Row>
                        <Row style={{ paddingTop: "25px" }}>
                            <Col md="12" style={{ padding: "15px" }}>
                                <Button onClick={() => createDraft()} disabled={!email || working} size="lg" variant="swiftrev">Next</Button>
                            </Col>
                        </Row>
                    </Container>
                </Fragment>
            }
        </BrandContext.Consumer>
    );
}